import { useState } from 'react';

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitted(true);
      return;
    }
    setSubmitted(true);
    form.reset();
  };

  if (submitted) {
    return (
      <section id="contact" className="w-full py-16 md:py-22 bg-background-100">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
          <div className="max-w-lg mx-auto bg-background-50 rounded-2xl p-10 border border-background-200/60">
            <div className="w-16 h-16 mx-auto rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-check-line text-3xl text-primary-600"></i>
            </div>
            <h2 className="font-heading text-2xl text-foreground-950 mt-6">消息已收到</h2>
            <p className="text-sm text-foreground-500 mt-3">感谢你的来信，我们会尽快回复！</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="contact" className="w-full py-16 md:py-22 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
              联系我们
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500 leading-relaxed">
              有想看的漫画推荐？遇到了使用问题？或者想投稿合作？欢迎通过下方表单联系我们，YY漫画团队期待你的声音。
            </p>
            <div className="mt-8 space-y-5">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-primary-600"></i>
                </div>
                <div>
                  <div className="font-bold text-sm text-foreground-900">投稿与合作</div>
                  <div className="text-xs text-foreground-500 mt-0.5">contact@yymanhua.com</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-question-answer-line text-accent-600"></i>
                </div>
                <div>
                  <div className="font-bold text-sm text-foreground-900">问题反馈</div>
                  <div className="text-xs text-foreground-500 mt-0.5">support@yymanhua.com</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-shake-hands-line text-secondary-600"></i>
                </div>
                <div>
                  <div className="font-bold text-sm text-foreground-900">商务洽谈</div>
                  <div className="text-xs text-foreground-500 mt-0.5">biz@yymanhua.com</div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/60">
            <form onSubmit={handleSubmit} data-readdy-form="">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                  <input
                    type="text"
                    name="name"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                    placeholder="你的名字"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                  <input
                    type="email"
                    name="email"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                    placeholder="your@email.com"
                  />
                </div>
              </div>
              <div className="mt-4">
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
                <select
                  name="subject"
                  required
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors cursor-pointer"
                >
                  <option value="">请选择主题</option>
                  <option value="recommend">漫画推荐</option>
                  <option value="feedback">问题反馈</option>
                  <option value="cooperation">合作洽谈</option>
                  <option value="other">其他</option>
                </select>
              </div>
              <div className="mt-4">
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                <textarea
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                  placeholder="请描述你想说的话（最多500字）"
                ></textarea>
                <div className="text-xs text-foreground-400 mt-1 text-right">最多500字</div>
              </div>
              <input
                type="text"
                name="website_alt"
                className="form-anti-spam"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <button
                type="submit"
                className="w-full mt-5 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-sm rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                发送消息
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}